import Vue from "vue";
import Router from "vue-router";

import DefaultLayout from "@/layouts/defaultLayout.vue";

Vue.use(Router);

export default new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            component: DefaultLayout,
            children: [
                {
                    path: "",
                    name: "HomePage",
                    component: () => import('@/pages/Home.vue'),
                },
                {
                    path: "en",
                    redirect: "/"
                },
                {
                    path: "fr",
                    redirect: "/"
                },
            ],
        },
        {
            path: "/recrutement-tech",
            redirect: "/recrutement"
        },
        {
            path: "/recrutement",
            component: DefaultLayout,
            children: [
                {
                    path: "",
                    name: "RecruitmentPage",
                    component: () => import('@/pages/ServicesType.vue'),
                    meta: {
                        isRecruitment: true
                    }
                },
            ],
        },
        {
            path: "/executive-search",
            component: DefaultLayout,
            children: [
                {
                    path: "",
                    name: "ExecutiveSearchPage",
                    component: () => import('@/pages/ServicesType.vue'),
                },
            ],
        },
        {
            path: "/rpo",
            component: DefaultLayout,
            children: [
                {
                    path: "",
                    name: "RPOPage",
                    component: () => import('@/pages/ServicesType.vue'),
                    meta: {
                        isRPO: true
                    }
                },
            ],
        },
        // {
        //     path: "/services",
        //     component: DefaultLayout,
        //     children: [
        //         {
        //             path: "",
        //             name: "ServicesPage",
        //             component: () => import('@/pages/Services.vue')
        //         },
        //         {
        //             path: "recrutement",
        //             name: "RecruitmentPage",
        //             component: () => import('@/pages/ServicesType.vue'),
        //             meta: {
        //                 isRecruitment: true
        //             }
        //         },
        //         {
        //             path: "executive-search",
        //             name: "ServicesExecutiveSearch",
        //             component: () => import('@/pages/ServicesType.vue'),
        //         },
        //         {
        //             path: "recruitment-process-outsourcing",
        //             name: "RPOPage",
        //             component: () => import('@/pages/ServicesType.vue'),
        //             meta: {
        //                 isRPO: true
        //             }
        //         },
        //     ],
        // },
        // {
        //     path: "/en/our-services",
        //     redirect: "/services"
        // },
        // {
        //     path: "/fr/our-services",
        //     redirect: "/services"
        // },
        // {
        //     path: "/en/service/recruitment",
        //     redirect: "/services/recrutement"
        // },
        {
            path: "/deposer-une-offre",
            redirect: "/deposez-votre-offre"
        },
        {
            path: "/deposez-votre-offre",
            component: DefaultLayout,
            children: [
                {
                    path: "",
                    name: "SubmitYourOfferPage",
                    component: () => import('@/pages/Contact.vue'),
                    meta: {
                        isEnterprise: true
                    }
                },
            ],
        },
        {
            path: "/notre-approche",
            component: DefaultLayout,
            children: [
                {
                    path: "",
                    name: "OurApproachPage",
                    component: () => import('@/pages/OurApproach.vue'),
                },
            ],
        },
        {
            path: "/deposer-votre-cv/:offerName?",
            component: DefaultLayout,
            children: [
                {
                    path: "",
                    name: "SubmitYourResumePage",
                    component: () => import('@/pages/Contact.vue'),
                },
            ],
        },
        // {
        //     path: "/contact",
        //     component: DefaultLayout,
        //     children: [
        //         {
        //             path: "candidature/:offerName?",
        //             name: "SubmitYourResumePage",
        //             component: () => import('@/pages/Contact.vue'),
        //         },
        //         {
        //             path: "deposer-votre-offre",
        //             name: "SubmitYourOfferPage",
        //             component: () => import('@/pages/Contact.vue'),
        //             meta: {
        //                 isEnterprise: true
        //             }
        //         }
        //     ],
        // },
        {
            path: "/fr/contact-us",
            redirect: "/#contact"
        },
        {
            path: "/en/contact-us",
            redirect: "/#contact"
        },
        {
            path: "/missions",
            component: DefaultLayout,
            children: [
                {
                    path: "",
                    name: "MissionsPage",
                    redirect: "/",
                    component: () => import('@/pages/Offers.vue'),
                },
                {
                    path: "/missions/:offerName?",
                    name: "MissionDetailsPage",
                    component: () => import('@/pages/Offers.vue'),
                }
            ],
        },
        {
            path: "/a-propos",
            component: DefaultLayout,
            children: [
                {
                    path: "",
                    name: "AboutPage",
                    component: () => import('@/pages/About.vue'),
                }
            ],
        },
        {
            path: "/notre-offre",
            component: DefaultLayout,
            children: [
                {
                    path: "",
                    name: "OurOfferPage",
                    component: () => import('@/pages/OurOffer.vue'),
                }
            ],
        },
        {
            path: "/offers",
            redirect: "/missions"
        },{
            path: "/fr/missions",
            redirect: "/missions"
        },
        {
            path: "/en/missions",
            redirect: "/missions"
        },
        {
            path: "/mentions-legales",
            component: DefaultLayout,
            children: [
                {
                    path: "",
                    name: "LegalNoticePage",
                    component: () => import('@/pages/LegalNotice.vue'),
                }
            ],
        },
        {
            path: "/politique-de-confidentialite-et-cgu",
            component: DefaultLayout,
            children: [
                {
                    path: "",
                    name: "PrivacyPolicyPage",
                    component: () => import('@/pages/PrivacyPolicy.vue'),
                }
            ],
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            if (to.hash === '#contact') {
                return new Promise((resolve) => {
                    setTimeout(() => {
                        const element = document.querySelector(to.hash);

                        if (element) {
                            const top = element.getBoundingClientRect().top + window.scrollY - 150;

                            window.scrollTo({ top, behavior: 'smooth' });
                        }
                        resolve();
                    }, 300);
                });
            } else {
                return {
                    selector: to.hash,
                    behavior: 'smooth'
                };
            }
        }

        return savedPosition ? savedPosition : { x: 0, y: 0 }
    }
});
